import { useState, useCallback } from 'react'

const KEY = 'selah_intro_seen'

export function useIntroSeen() {
  const [seen, setSeen] = useState(() => localStorage.getItem(KEY) === '1')

  const markSeen = useCallback(() => {
    localStorage.setItem(KEY, '1')
    setSeen(true)
  }, [])

  return { introSeen: seen, markIntroSeen: markSeen }
}
